var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('AppHeader'),_c('div',{staticClass:"app-body"},[_c('main',{staticClass:"main"},[_c('div',{style:({ backgroundColor: _vm.sfondoBody })},[_vm._v(" ")]),_c('div',{staticClass:"container-fluid",style:({ backgroundColor: _vm.sfondoBody, height: '100%' })},[_c('router-view')],1)]),_c('AppAside')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }